import Block from 'components/Block';
import MetaTitle from 'components/MetaTitle';
import ErrorComponent from 'containers/Error';
import Layout from 'containers/Layout';
import Main from 'containers/Main';

export default function NotFound() {
  const statusCode = 404;
  const errorMessage = 'Not found';

  return (
    <Layout>
      <MetaTitle>{`${statusCode}: ${errorMessage}`}</MetaTitle>
      <Main>
        <Block>
          <ErrorComponent statusCode={statusCode} errorMessage={errorMessage} />
        </Block>
      </Main>
    </Layout>
  );
}
